import React, { useState } from 'react';

import { useGetGroupsListQuery, } from 'features/groups';

import { GroupsTable } from './components/GroupsTable';

const defaultPageSize = 30;

const initParams = {
  page: 1,
  pageSize: defaultPageSize,
};

interface Props {
  handleCreateClick: () => void;
  handleEditClick: (groupeId: number) => void;
}

export const TablePage = ({ handleCreateClick, handleEditClick }: Props) => {
  const [params, setParams] = useState(initParams);

  const {
    groupsList,
    groupsCount,
    isGroupsFetching,
  } = useGetGroupsListQuery(undefined, {
    selectFromResult: ({ data, isFetching }) => ({
      groupsList: data?.items ?? [],
      groupsCount: data?.count ?? 0,
      isGroupsFetching: isFetching,
    })
  });

  const handlePaginationChange = (page: number, pageSize: number) => {
    setParams((prev) => ({
      ...prev,
      page,
      pageSize,
    }));
  };

  return (
    <div>
      <GroupsTable
        items={groupsList}
        itemsTotal={groupsCount}
        currentPage={params.page}
        defaultPageSize={defaultPageSize}
        onPageChange={handlePaginationChange}
        isLoading={isGroupsFetching}
        onEditClick={handleEditClick}
        onCreateClick={handleCreateClick}
      />
    </div>
  );
};
